<app-studentInfo [student]="student"></app-studentInfo>
<div class="row" style="min-height: 600px;">
    <div class="col-sm-12">
        <iframe width="100%" height="100%" frameBorder="0" autocomplete="off" [src]="urlSafe"></iframe>
    </div>
</div>